// @flow
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const TopbarSearch = () => {
    const [searchKey, setSearchKey] = useState(null);

    const onChange = (e) => {
        setSearchKey(e.target.value);
    };

    return (
        <div className="app-search d-none d-lg-block">
            <form className="position-relative">
                <div className="input-group">
                    <input
                        className="form-control"
                        placeholder="At least 3 letters"
                        id="top-search"
                        onChange={onChange}
                    />
                    <span className="mdi mdi-magnify search-icon"></span>

                    <Link to={'/registration?search=' + searchKey}>
                        <button className="btn btn-secondary">Search</button>
                    </Link>
                </div>
            </form>
        </div>
    );
};

export default TopbarSearch;
